import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import {
  FolderOutlined,
  ToolOutlined,
  TeamOutlined,
  BookOutlined,
  VideoCameraOutlined,
  ShoppingOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const iconMap = {
  tools: <ToolOutlined />,
  social: <TeamOutlined />,
  learning: <BookOutlined />,
  video: <VideoCameraOutlined />,
  shopping: <ShoppingOutlined />,
  default: <FolderOutlined />
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [categories, setCategories] = useState([]);

  // 添加一个函数来加载分类
  const loadCategories = () => {
    const savedCategories = JSON.parse(localStorage.getItem('categories') || 'null');
    if (savedCategories) {
      setCategories(savedCategories);
    }
  };

  useEffect(() => {
    // 初始加载分类
    loadCategories();

    // 添加事件监听器来监听 localStorage 变化
    const handleStorageChange = (e) => {
      if (e.key === 'categories') {
        loadCategories();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // 创建一个定时器定期检查分类更新
    const intervalId = setInterval(loadCategories, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, []);

  const baseMenuItems = [
    {
      key: 'all',
      icon: <FolderOutlined />,
      label: '全部书签',
    },
    {
      key: 'categories',
      icon: <SettingOutlined />,
      label: '分类管理',
    }
  ];

  const categoryMenuItems = categories.map(category => ({
    key: category.key,
    icon: iconMap[category.key] || iconMap.default,
    label: category.name,
  }));

  const handleMenuClick = (item) => {
    navigate(`/category/${item.key}`);
  };

  return (
    <div className="sidebar">
      <Menu
        mode="inline"
        selectedKeys={[location.pathname.split('/')[2] || 'all']}
        items={[...baseMenuItems, ...categoryMenuItems]}
        onClick={handleMenuClick}
      />
    </div>
  );
};

export default Sidebar; 